module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CP5fOo/media/FC-9789948778073.jpg?1708992365074",
      "alt": "This image is the cover for the book قصص حب قصيرة"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("قصص حب قصيرة\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("عَبْرَ شوقٍ وقلقٍ وانتظار، متحدِّيةً جدار خوف وحذر وسكينة، تطلُّ المحبَّة بظلال وروائح ملوَّنة، تخترق أحلامنا، وتعيد صياغةَ ذاتٍ إنسانيَّة أتعبها عبث الحياة.  نخاف ملامحها الغريبة وعِطرها الممزوج برائحة مطر وصنوبر.  تُداعِب أفكارنا، وتتحوَّل ظلالها لوجوه ألِفْنا نقاءَها، وجوه هي نحن في عالم المحبَّة.  تسمُو بنا، تمدُّنا بقوَّة التحليق في فضاء لا يرضى إلَّا بألق حبٍّ خبا تحت غبار الزمن.  رحلات محبَّة قصيرة تتسارع أحداثها في عوالم لا تؤمِن بالتَّشابه، تسرق منَّا يقظة حذِرة، وندخل فيها دوائر حبٍّ، يبقى فيها الجوهر واحدًا رغمًا عن ظروف خارجة تلوَّثَت بغير الحبِّ، لتعلن انتصارًا يرتكز على مفهوم الإنسانيَّة المجرَّد.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      فاتن أبو فخر\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0